import { Component } from "preact";

/** @import WS from "~/lib/ws/ws.js"; */
/** @import { EventMap } from "~/lib/ws/ws.js"; */

/** @typedef {EventMap["message"]} Message */

/**
 * Subscribes to a {@link WS}'s `message` event for its mounted lifetime and
 * renders nothing. Calls {@link Props.on} with each message whose `action` is
 * listed in {@link Props.for}. Drop it into any component that needs to react to
 * socket messages (e.g. refetch a query on `admin_machine_refresh`) instead of
 * hand-rolling `componentDidMount`/`componentWillUnmount` and an
 * `AbortController` each time.
 *
 * @extends {Component<Props>}
 *
 * @typedef {object} Props
 * @property {WS} ws
 * @property {Message["action"][]} for Actions to react to; other messages are ignored.
 * @property {(message: Message) => void} on Called with each matching message.
 */
export default class WSListener extends Component {
	#unlisten = new AbortController();

	/** @override */
	componentDidMount() {
		this.props.ws.on(
			"message",
			({ detail }) => {
				if (this.props.for.includes(detail.action)) this.props.on(detail);
			},
			{ signal: this.#unlisten.signal },
		);
	}

	/** @override */
	componentWillUnmount() {
		this.#unlisten.abort();
	}

	render() {
		return null;
	}
}
